import React from 'react';
import ComboTotalPage from './components/ComboTotalPage';

function ComboTotalRosani() {
  return <ComboTotalPage paymentUrlOverride="https://pay.kiwify.com.br/yKYVFMc?afid=rosani" />;
}

export default ComboTotalRosani;
